import React from 'react'

class ProgressBar extends React.Component {
    render() {
        return (
            <div className='reducer-progress-bar-container'>
                <div className='reducer-progress-bar' style={{ width: this.props.percentComplete + '%' }}>
                    {this.props.percentComplete}&nbsp;%&nbsp;complete
                </div>
            </div>
        )
    }
}

export default ProgressBar




// WEBPACK FOOTER //
// ./src/scenes/reducer/components/ProgressBar/index.js